import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/styles/GlobalFlags.css";

const GlobalFlags = () => {
  return (
    <Container className="flags-page text-center py-5">
      <h2 className="mb-4 flags-title">
        We enable clients in 2 countries to drive continued growth through innovation, re-imagination, and transformation.
      </h2>
      <Row className="justify-content-center">
        {/* UAE Section */}
        <Col md={5} className="flag-section mb-4">
          <img src="/assets/ukFlag.jpeg" alt="uk Flag" className="flag-image" />
          <h4>United Kingdom</h4>
          <p>UK</p>
          <p><strong>Telephone:</strong> <a href="tel:+97143695325">+971 43695325</a></p>
        </Col>
          <Col md={1}></Col>
        {/* Pakistan Section */}
        <Col md={5} className="flag-section mb-4">
          <img src="/assets/pakistan.png" alt="Pakistan Flag" className="flag-image" />
          <h4>Pakistan</h4>
          <p>Lahore</p>
          <p><strong>Telephone:</strong> <a href="tel:+97143695325">+92 3207110715</a></p>
        </Col>
      </Row>
    </Container>
  );
};

export default GlobalFlags;
